/**
* @Author 22030124/xieyq
* @Date 2023-11-24 16:57:29
* @Description vue eventbus对象
*/
import Vue from 'vue'
// 导出一个vue实例
export default new Vue()
